var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 31,
    viewBox: "0 0 41 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84375 0C1.73503 0 0.01001 1.73568 0 3.86155C0 3.86155 0 3.86491 0 3.86827C0 3.87164 0 3.87164 0 3.875V27.125C0 29.2542 1.73169 31 3.84375 31H37.1562C39.2683 31 41 29.2542 41 27.125V3.875C41 3.87164 41 3.87164 41 3.86827C41 3.86491 41 3.86155 41 3.86155C40.99 1.73568 39.265 0 37.1562 0H3.84375ZM6.06592 1.72222H34.9374L20.5 11.8672L6.06592 1.72222ZM3.22315 1.82313L20.5 13.9661L37.7802 1.82313C38.6544 2.08887 39.285 2.88943 39.2917 3.86491C39.2883 4.04655 39.1048 4.40983 38.8379 4.70247C38.5676 4.99848 38.304 5.18349 38.304 5.18349L38.3007 5.19021L20.5 17.8916L2.6993 5.19021L2.69596 5.18349C2.69596 5.18349 2.43237 4.99848 2.16211 4.70247C1.89518 4.40983 1.71167 4.04655 1.70833 3.86491C1.71501 2.88943 2.34562 2.08887 3.22315 1.82313ZM1.70833 6.58952L1.71501 6.59625L1.72168 6.59961V6.60297L4.27083 8.41938V29.2778H3.84375C2.65592 29.2778 1.70833 28.3225 1.70833 27.125V6.58952ZM39.2917 6.58952V27.125C39.2917 28.3225 38.3441 29.2778 37.1562 29.2778H36.7292V8.41938L39.2783 6.60297V6.59961L39.2917 6.58952ZM5.97917 9.63704L20.5 19.9973L35.0208 9.63704V29.2778H5.97917V9.63704Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.a8857a632977b81dbaa4f52ef79f39ee.svg";
export { ForwardRef as ReactComponent };